import { memo } from 'react';
import useWidth from '../../../../../../../../../../components/Hooks/useWidth';
import { SelloutSku } from '../../../../../../../../../../services/modules/product-color-sellout/product-color-sellout.types';
import { SelloutDistribution } from '../types/selloutDistribution.types';
import { SelloutDistributionRowComponentProps } from '../types/selloutDistributionRow.types';
import SelloutDesktopDistributionRow from './desktop/components/SelloutDesktopDistributionRow';
import SelloutDistributionRowMobile from './mobile/components/SelloutDistributionRowMobile';

interface SelloutDistributionRowProps {
  pieces: number;
  disabled: boolean;
  selloutSkus: SelloutSku[];
  distribution: SelloutDistribution[];
  onChangePieces: (value: number) => void;
}

const SelloutDistributionRow = ({
  pieces,
  disabled,
  selloutSkus,
  distribution,
  onChangePieces,
}: SelloutDistributionRowProps) => {
  const { mobileWidth } = useWidth();

  const props: SelloutDistributionRowComponentProps = {
    disabled,
    selloutSkus,
    distribution,
  };

  if (mobileWidth) {
    return (
      <SelloutDistributionRowMobile {...props} pieces={pieces} onChangePieces={onChangePieces} />
    );
  }

  return <SelloutDesktopDistributionRow {...props} />;
};

export default memo(SelloutDistributionRow);
